import * as React from "react";
import type { SVGProps } from "react";
const SvgMorehorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="morehorizontal_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M213.333 426.667a85.333 85.333 0 1 0 0 170.666 85.333 85.333 0 0 0 0-170.666zM426.667 512a85.333 85.333 0 1 1 170.666 0 85.333 85.333 0 0 1-170.666 0zm298.666 0A85.333 85.333 0 1 1 896 512a85.333 85.333 0 0 1-170.667 0z"
    />
  </svg>
);
export default SvgMorehorizontalIcon;
